module.exports = __webpack_public_path__ + "static/img/main_background.56d7014.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brands/mill/main_background.jpg
// module id = hcLx
// module chunks = 1